import type { Tournament } from '@/types';

/**
 * Normalizes raw tournament list rows into the camelCase `Tournament` shape.
 * `/tournaments` and `/tournaments/archived` already answer in camelCase;
 * `/public/tournaments` answers in snake_case with string counts.
 */
export function normalizeTournaments(raw: any[] | null | undefined): Tournament[] {
  if (!Array.isArray(raw)) return [];
  return raw.map((t) => ({
    ...t,
    isActive: t.is_active ?? t.isActive,
    matchesCount: parseInt(String(t.matches_count ?? t.matchesCount ?? 0), 10) || 0,
    participantsCount: parseInt(String(t.participants_count ?? t.participantsCount ?? 0), 10) || 0,
    leagueName: t.league_name ?? t.leagueName,
    leagueLogo: t.league_logo ?? t.leagueLogo,
    createdAt: t.created_at ?? t.createdAt,
    firstMatchDate: t.first_match_date ?? t.firstMatchDate,
    nextMatchDate: t.next_match_date ?? t.nextMatchDate,
    unfinishedMatchesCount: t.unfinished_matches_count ?? t.unfinishedMatchesCount,
    listStatus: t.list_status ?? t.listStatus,
    isFavorite: t.is_favorite ?? t.isFavorite,
  }));
}
